import { AuthService } from '../../../abstraction/auth.service';
import { Component, Input, OnInit } from '@angular/core';
import { ICryptoPortfolio } from '../../../models/Crypto';
import { CryptoService } from '../../../abstraction/crypto.service';

@Component({
  selector: 'app-detail-balance',
  templateUrl: './detail-balance.component.html',
  styleUrls: ['./detail-balance.component.scss'],
})
export class DetailBalanceComponent implements OnInit {
  @Input() selectedTab;
  cryptoBalances: ICryptoPortfolio[] = [];

  constructor(public auth: AuthService, private cryptoSvc: CryptoService) {}

  ngOnInit(): void {
    this.auth.myCryptoPortfolio.subscribe((data: ICryptoPortfolio[]) => {
      this.cryptoBalances = data
        .filter((balance) => {
          // Ocultar los balances que no tienen el minimo suficiente para mostrar en portfolio
          return Number(balance.balanceArs) >= 1;
        })
        .sort((a, b) => {
          if (a.ticker.includes('USDT')) return -1;
          return Number(b.balance) - Number(a.balance);
        });
    });
  }
}
